// @flow

import React, { PureComponent } from 'react';

import s from './Paginator.scss';
import paginator from "paginator";

type Pagination = {
  first_page: number,
  last_page: number,
  total_pages: number,
  current_page: number,
  previous_page: number,
  next_page: number,
  has_previous_page: boolean,
  has_next_page: boolean,
  total_results: number,
  results: number,
  first_result: number,
  last_result: number,
}

type Props = {
  limit: number,
  total: number,
  activePage: number,
  onPaginatorClick: (page: number) => void,
}

type State = {
}

export class Paginator extends PureComponent<Props, State> {
  render() {
    const { limit, total, onPaginatorClick, activePage } = this.props;

    const pagination = new paginator(limit, 5).build(total, activePage);
    const { total_pages, next_page, previous_page, has_next_page, has_previous_page } = pagination;

    return (
      <div id={s.paginator}>
        <button
          onClick={() => onPaginatorClick(1)}
          className={[s.btn, s.first_last_btn].join(" ")}
          disabled={!has_previous_page}
          data-testid="paginator-first-button"
        >
          FIRST
        </button>
        <button
          onClick={() => onPaginatorClick(previous_page)}
          className={[s.btn, s.down_arrow].join(" ")}
          disabled={!has_previous_page}
        >
          <svg version="1.1" id="Capa_1" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 124.512 124.512">
            <g>{" "}
              <path
                className={s.icon}
                fill="#0075AC"
                d="M113.956,57.006l-97.4-56.2c-4-2.3-9,0.6-9,5.2v112.5c0,4.6,5,7.5,9,5.2l97.4-56.2 C117.956,65.105,117.956,59.306,113.956,57.006z"
              />{" "}
            </g>
          </svg>
        </button>

        {this.renderPages(pagination)}

        <button
          onClick={() => onPaginatorClick(next_page)}
          className={[s.btn, s.up_arrow].join(" ")}
          disabled={!has_next_page}
        >
          <svg version="1.1" id="Capa_2" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 124.512 124.512">
            <g>{" "}
              <path
                className={s.icon}
                fill="#0075AC"
                d="M113.956,57.006l-97.4-56.2c-4-2.3-9,0.6-9,5.2v112.5c0,4.6,5,7.5,9,5.2l97.4-56.2 C117.956,65.105,117.956,59.306,113.956,57.006z"
              />{" "}
            </g>
          </svg>
        </button>

        <button
          onClick={() => onPaginatorClick(total_pages)}
          className={[s.btn, s.first_last_btn].join(" ")}
          disabled={!has_next_page}
          data-testid="paginator-last-button"
        >
          LAST
        </button>
      </div>
    );
  }

  renderPages(pagination: Pagination) {
    const { onPaginatorClick, activePage } = this.props;
    const { first_page, last_page } = pagination;
    const pages = [];

    for (let i = first_page; i <= last_page; i += 1) {
      pages.push (
        <button
          key={i}
          onClick={() => onPaginatorClick(i)}
          className={[s.btn, s.page].join(' ')}
          disabled={false}
          data-active={activePage === i}
        >
          {i}
        </button>
      )
    }

    return pages;
  }


}

export default Paginator;

